import axiosClient from "./axiosClient"

const categoriesApi = {
  getAll: params =>
    axiosClient.get("/categories/", { params, authRequired: true }),
  getArticlesByCategoryId: (categoryId, params) =>
    axiosClient.get(`/categories/${categoryId}/articles/`, {
      params,
      authRequired: true,
    }),
  getArticlesByCategoryName: (categoryName, params) =>
    axiosClient.get(`/categories/${categoryName}/articles/`, {
      params,
      authRequired: true,
    }),
  getById: id => axiosClient.get(`/categories/${id}/`),
}

export default categoriesApi
